import React, { type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';
import { ScrollView } from 'react-native-gesture-handler';
import { theme, useResponsive } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationDetailsContainer = (props: PropsWithChildren) => {
  const { match } = useResponsive();
  const containerStyles = [
    styles.container,
    match([styles.containerXS, styles.containerSM, styles.containerLG]),
  ];

  return (
    <ScrollView contentContainerStyle={containerStyles}>
      {props.children}
    </ScrollView>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexGrow: 1,
    rowGap: theme.spacing['4'],
    marginBottom: theme.spacing['4'],
    paddingBottom: theme.spacing['8'],
  },
  containerXS: {
    paddingHorizontal: theme.spacing['4'],
  },
  containerSM: {
    paddingHorizontal: theme.spacing['6'],
  },
  containerLG: {
    paddingHorizontal: theme.spacing['10'],
  },
});
